/** @file clamp: limits a number to a closed range. */

/** `x` limited to [lo, hi]; NaN stays NaN. */
export function clamp(x: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, x));
}
